// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file calendar/calendar_errors.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file calendar/calendar_errors.proto.
 */
export const file_calendar_calendar_errors: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Ch5jYWxlbmRhci9jYWxlbmRhcl9lcnJvcnMucHJvdG8SFGNvbS5nZW0uYmZmLmNvbnRyYWN0IiwKDUNhbGVuZGFyRXJyb3IaDgoMVW5hdXRob3JpemVkGgsKCUZvcmJpZGRlbkIYChRjb20uZ2VtLmJmZi5jb250cmFjdFABYgZwcm90bzM'
  );

/**
 * @generated from message com.gem.bff.contract.CalendarError
 */
export type CalendarError = Message<'com.gem.bff.contract.CalendarError'> & {};

/**
 * Describes the message com.gem.bff.contract.CalendarError.
 * Use `create(CalendarErrorSchema)` to create a new message.
 */
export const CalendarErrorSchema: GenMessage<CalendarError> =
  /*@__PURE__*/
  messageDesc(file_calendar_calendar_errors, 0);

/**
 * E_UNAUTHORIZED
 *
 * @generated from message com.gem.bff.contract.CalendarError.Unauthorized
 */
export type CalendarError_Unauthorized =
  Message<'com.gem.bff.contract.CalendarError.Unauthorized'> & {};

/**
 * Describes the message com.gem.bff.contract.CalendarError.Unauthorized.
 * Use `create(CalendarError_UnauthorizedSchema)` to create a new message.
 */
export const CalendarError_UnauthorizedSchema: GenMessage<CalendarError_Unauthorized> =
  /*@__PURE__*/
  messageDesc(file_calendar_calendar_errors, 0, 0);

/**
 * E_FORBIDDEN
 *
 * @generated from message com.gem.bff.contract.CalendarError.Forbidden
 */
export type CalendarError_Forbidden = Message<'com.gem.bff.contract.CalendarError.Forbidden'> & {};

/**
 * Describes the message com.gem.bff.contract.CalendarError.Forbidden.
 * Use `create(CalendarError_ForbiddenSchema)` to create a new message.
 */
export const CalendarError_ForbiddenSchema: GenMessage<CalendarError_Forbidden> =
  /*@__PURE__*/
  messageDesc(file_calendar_calendar_errors, 0, 1);
